import React, { useEffect, useState } from 'react';
import { InlineLoading } from 'carbon-components-react';

const IFrameViewer: React.FC<Props> = ({
  source,
  className,
  title,
  viewerContentHeight
}) => {
  const [isFrameLoading, setIsFrameLoading] = useState(true);

  useEffect(() => {
    setIsFrameLoading(true);
  }, [source]);

  const handleWebmapLoad = () => {
    setIsFrameLoading(false);
    return;
  };
  return (
    <>
      {isFrameLoading && (
        <div
          style={{
            display: 'flex',
            height: `calc(${viewerContentHeight} - 3rem)`,
            minHeight: '24rem',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <InlineLoading
            style={{ justifyContent: 'center' }}
            description="Preparing response view ..."
          />
        </div>
      )}
      <iframe
        className={className}
        src={source}
        title={title}
        onLoad={handleWebmapLoad}
      ></iframe>
    </>
  );
};

type Props = {
  source: string;
  selectedData: any;
  className: string;
  title: string;
  viewerContentHeight?: any;
};

export default React.memo(IFrameViewer);
